import { useNavigate, Link } from 'react-router-dom';
import styled from 'styled-components';
import { LoginForm } from '../../organisms';
import { authService } from '../../../services/authService';
import { userService } from '../../../services/userService';
import { useAuthStore } from '../../../store/authStore';
import { useState } from 'react';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
`;

const MessageBox = styled.div`
  margin-top: 16px;
  padding: 12px;
  border-radius: 4px;
  text-align: center;
  max-width: 400px;
`;

const ErrorMessage = styled(MessageBox)`
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c33;
`;

const RegisterLink = styled(MessageBox)`
  background-color: white;
  border: 1px solid #ddd;
  color: #666;

  a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const LoginPage = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore(state => state.setUser);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async ({ email, password }) => {
    setLoading(true);
    setError('');

    try {
      // 1. Firebase Authentication 로그인
      const user = await authService.login(email, password);

      // 2. Firestore에서 사용자 프로필 정보 가져오기
      const userProfile = await userService.getUserDocument(user.uid);

      // 3. 전역 상태에 저장
      setUser(user, userProfile);

      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError('로그인에 실패했습니다. 이메일과 비밀번호를 확인해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Wrapper>
        <LoginForm onSubmit={handleLogin} disabled={loading} />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <RegisterLink>
          계정이 없으신가요? <Link to="/register">회원가입하기</Link>
        </RegisterLink>
      </Wrapper>
    </Container>
  );
};

export default LoginPage;
